"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gotoChatByIndex = exports.gotoChatById = exports.GOTO_CHAT = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const CurrentUserTypingHandler_1 = __importDefault(require("../../domain/CurrentUserTypingHandler"));
const MarkAsReadHandler_1 = __importDefault(require("../../domain/MarkAsReadHandler"));
const notifications = __importStar(require("../../notifications"));
exports.GOTO_CHAT = "GOTO_CHAT";
function gotoChatById(chatId, messageId, fromHistory) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        let chatsState = getState().chatsState;
        let chatIndex = chatFunctions.findChatIndex(chatsState.chats, chatId);
        if (chatIndex == -1) {
            chatIndex = 0;
        }
        return gotoChat(dispatch, chatsState, chatIndex, messageId, fromHistory);
    });
}
exports.gotoChatById = gotoChatById;
function gotoChatByIndex(chatIndex, messageId) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        return gotoChat(dispatch, getState().chatsState, chatIndex, messageId, false);
    });
}
exports.gotoChatByIndex = gotoChatByIndex;
function gotoChat(dispatch, chatsState, chatIndex, messageId, fromHistory) {
    return __awaiter(this, void 0, void 0, function* () {
        if (chatIndex === chatsState.selectedChatIndex && !messageId) {
            return null;
        }
        if (chatsState.selectedChatIndex != null && chatIndex !== chatsState.selectedChatIndex) {
            const prevChat = chatsState.chats[chatsState.selectedChatIndex];
            if (chatFunctions.isConfirmedChat(prevChat)) {
                CurrentUserTypingHandler_1.default.markTypingStopped(prevChat.chatId);
                MarkAsReadHandler_1.default.updateServer();
            }
        }
        let missingMessages = [];
        const chat = chatsState.chats[chatIndex];
        if (chat) {
            // Load missing messages if necessary
            if (messageId) {
                const messages = yield loadMissingMessages(chat, messageId);
                if (messages != null) {
                    missingMessages = messages;
                    // The message was missing - check that we now have it
                    if (messages.find(m => m.id === messageId) == undefined) {
                        messageId = undefined;
                    }
                }
            }
            notifications.close(chat.chatId);
        }
        const event = {
            type: exports.GOTO_CHAT,
            payload: {
                chatIndex,
                messageId: messageId !== null && messageId !== void 0 ? messageId : null,
                missingMessages,
                fromHistory: fromHistory !== null && fromHistory !== void 0 ? fromHistory : false
            }
        };
        dispatch(event);
        return event;
    });
}
function loadMissingMessages(chat, messageId) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const excessMessages = 20;
        const from = Math.max(1, messageId - excessMessages);
        const to = (_a = chat.minLocalMessageId) !== null && _a !== void 0 ? _a : (messageId + excessMessages);
        let pageSize = to - from;
        if (pageSize <= 0) {
            return null;
        }
        // Load missing messages
        const result = yield service_1.default.getMessages(chat.chatId, from, pageSize);
        if (result.kind !== "success") {
            console.log(result);
            return [];
        }
        return result.result.messages;
    });
}
